export const GUT_BUTTON_PERMISSIONS = {
  'user-dashboard': {
    // Read-only view of the client's gut health trackers; open to everyone who
    // can open the client dashboard, like Hormonal Wellness.
    'view-gut-health-tab': { departments: [], roles: [] },
  },
};

/** Gut health feature access — registered in configs/featureAccess. */
export const gutAccess = {
  id: 'gut',
  routes: {},
  buttons: GUT_BUTTON_PERMISSIONS,
};
